// Auto-generated API configuration
export const API_CONFIG = {
    CONTACT_ENDPOINT: 'https://9ifcmshb3m.execute-api.us-east-1.amazonaws.com/prod/contact'
};